module.exports = __webpack_public_path__ + "static/media/bluedolphin.7c1e2e6a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/bluedolphin.webp
// module id = 494
// module chunks = 0